/** Human-readable store status for detail views (API returns enum strings like ACTIVE). */
export function formatStoreStatusLabel(
  status: string,
  t: (key: string, defaultMessage: string) => string
): string {
  const normalized = status.toLowerCase();
  const fallbacks: Record<string, string> = {
    pending: "Pending",
    active: "Active",
    suspended: "Suspended",
    deleted: "Deleted"
  };
  return t(`store-status-${normalized}`, fallbacks[normalized] ?? status);
}
